import { render } from "./Page4.vue?vue&type=template&id=14b412f6&scoped=true"
const script = {}

import "./Page4.vue?vue&type=style&index=0&id=14b412f6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b412f6"]])

export default __exports__